// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"6e23c15f","239":"358716b2","453":"64cf1258","455":"cf26671f","977":"f0b4d0d2"}[chunkId] + ".chunk.js";
};